import React from "react";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import { connect, useSelector } from "react-redux";
import * as advertRedux from "modules/Advert/_redux/advertRedux";
import { FLOOR_ORDER } from "helpers/floorOrder";

// Satıcı ilanı: konutun bulunduğu kat (sıralı enum, tek değer).
// Redux: newAdvert.filters.bulunduguKat (etiket) -> backend idx'i türetir.
function FLBulunduguKatSelect(props) {
  const { filters } = useSelector((state) => ({
    filters: state.advert.newAdvert.filters,
  }));

  const value = filters?.bulunduguKat ?? "";

  return (
    <TextField
      select
      label={props.filter.title || "Bulunduğu Kat"}
      variant="outlined"
      margin="dense"
      fullWidth
      value={value}
      onChange={(e) => props.editNewAdvertFilters("bulunduguKat", e.target.value)}
    >
      <MenuItem value="">
        <em>Seçiniz</em>
      </MenuItem>
      {FLOOR_ORDER.map((label) => (
        <MenuItem key={label} value={label}>
          {label}
        </MenuItem>
      ))}
    </TextField>
  );
}

export default connect(null, { ...advertRedux.actions })(FLBulunduguKatSelect);
